export const recordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const recordStatus = [
  { key: recordStatusMode.ACTIVE, badgeColor: "success" },
  { key: recordStatusMode.INACTIVE, badgeColor: "danger" },
];

export const userTypeMode = {
  RUNNER: "runner",
  COLLECTOR: "collector",
};

export const userType = [
  { key: userTypeMode.RUNNER, badgeColor: "info" },
  { key: userTypeMode.COLLECTOR, badgeColor: "primary" },
];

export const getUserTypeOption = (t, userTypeValue) => ({
  value: userTypeValue,
  label: t(`table.user_type.${userTypeValue}`),
});

export const MODE_DETAIL = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};
